import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Rule, AssetManagement, AssetVerify, AssetView, Environment } from '@aptsi-types';
import { environment } from '@env';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorHandlingService } from '../../../../shared/errorHandling/errorHandling.service';
import { API_ENDPOINTS } from '../../secure-zone-api-endpoints';


interface GetEnvironmentsResponse {
  environments: Environment[];
}

interface GetEnvironmentResponse {
  environment: Environment;
}


@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  private readonly apiUrl = environment.apiUrl;
  constructor(private http: HttpClient, private errorHandlingService: ErrorHandlingService) { }

  getEnvironments( currentPage: number): Observable<Environment[]> {
    return this.http.post<GetEnvironmentsResponse>(`${this.apiUrl}${API_ENDPOINTS.ENVIRONMENT.FETCH}`, { currentPage })
      .pipe(
        map(response => response.environments),
        catchError(error => this.errorHandlingService.handleError(error))
      );
  }

  getEnvironment(environmentId: string): Observable<Environment> {
    return this.http.post<GetEnvironmentResponse>(`${this.apiUrl}${API_ENDPOINTS.ENVIRONMENT.GET}`, { environmentId })
      .pipe(
        map(response => response.environment),
        catchError(error => this.errorHandlingService.handleError(error))
      );
  }

  
  getEnvironmentsSearch(currentPage:number, searchText:String, filterByHeader: String): Observable<Environment[]> {
    return this.http.post<GetEnvironmentsResponse>(`${this.apiUrl}${API_ENDPOINTS.ENVIRONMENT.SEARCH}`, { currentPage, searchText, filterByHeader })
      .pipe(
        map(response => response.environments),
        catchError(error => this.errorHandlingService.handleError(error))
      );
  }

  createEnvironment(environmentName: string, description: string, organizationId: string): Observable<any> {
    return this.http.post(`${this.apiUrl}${API_ENDPOINTS.ENVIRONMENT.CREATE}`, { environmentName, description, organizationId })
      .pipe(
        catchError(error => this.errorHandlingService.handleError(error))
       );
  }

   updateEnvironment(environmentId: string, environmentName: string, description: string, organizationId: string): Observable<any> {
    return this.http.post(`${this.apiUrl}${API_ENDPOINTS.ENVIRONMENT.UPDATE}`, { environmentId, environmentName, description, organizationId })
      .pipe(
        catchError(error => this.errorHandlingService.handleError(error))
       );
  }

  deleteEnvironment(environmentId: string): Observable<any> {
    return this.http.post(`${this.apiUrl}${API_ENDPOINTS.ENVIRONMENT.DELETE}`, { environmentId })
      .pipe(
        catchError(error => this.errorHandlingService.handleError(error))
       );
  }

}

